export default function auth({
    next,
    router
}) {
    if (localStorage.getItem('hasRegister')) return router.push({
        name: 'home'
    });

    return next();
}